import React, { useState } from "react";
import { CompactPicker, BlockPicker, TwitterPicker } from 'react-color';
import UpdateCustomerOriginMutation from '../../../graphql/customer-origin/mutations/UpdateCustomerOriginMutation';
import { ButtonSave, ButtonCancel } from '../../../components/Buttons';
import { Formik } from 'formik';
import * as Yup from "yup";


export default (props) => {



    const update = data => {
        UpdateCustomerOriginMutation({ ...data }, (response) => {
            if (response.status === 'OK') {
                props.doClose({
                    ...response, msgSnackbar: {
                        message: 'C bon c fait',
                        variant: 'success',
                        open: true,
                    }
                });
            } else {
                console.log({ error: 'Erreur' });
            }

        });
    }

    return (
        <Formik
            initialValues={{ id: props.data.id, name: props.data.name }}
            validationSchema={Yup.object().shape({
                name: Yup.string().required("Required")
            })}
            onSubmit={(values, { setSubmitting }) => {
                update({ id: props.data.id, ...values });
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue
                /* and other goodies */
            }) => (
                    <form onSubmit={handleSubmit} className="p-5">
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">LIBELLE:</label>
                            <div className="col-sm-8">
                                <input
                                    type="text"
                                    name="name"
                                    className={
                                        errors.name && touched.name
                                            ? "form-control form-control-sm is-invalid"
                                            : "form-control form-control-sm"}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={(values.name) ? values.name : ''} />
                                {errors.name && touched.name && (
                                    <div className="invalid-feedback">{errors.name}</div>
                                )}
                            </div>

                        </div>

                        <div className="form-group row">
                            <div className="col-md-12 text-right">
                                <ButtonCancel onClick={() => props.doClose()}></ButtonCancel>
                                <ButtonSave onClick={() => handleSubmit()}></ButtonSave>
                            </div>
                        </div>
                    </form>

                )}
        </Formik>
    )
}

